import Component from "@glimmer/component";
import icon from "discourse/helpers/d-icon";

export default class InvoiceDetailError extends Component {
  get validationError() {
    return this.args.validationErrors?.[this.args.fieldName];
  }

  <template>
    {{#if this.validationError}}
      <div class="invoice-details-error">
        {{icon "xmark"}}
        {{this.validationError}}
      </div>
    {{/if}}
  </template>
}
